export default "__VITE_ASSET__Ds0mcYla__"